import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.PURPLE,
    codeProp: 'lsiNo',
    detailIdProp: 'lsiId',
    detailUrl: '/LsiDetail',
    listUrl: '/LsiList',
    mapProp: 'lsiMap',
    name: '外联接口',
    textProp: 'lsiName',
    type: 'LSI',
}
